import { appendIf } from '@btime/helpers'
import { prop } from 'ramda'
import React from 'react'

import { useAccordionActions } from '../../../../components/structure/accordion/AccordionHandler'
import { useNavigationWithModalCloser } from '../../../../utils/contexts/NavigationContext'
import { useOpenServiceOrderModal } from '../../../../utils/routes/modals/modalsActions'
import { useServiceOrderPermissions } from '../../../../utils/permissions/serviceOrders/serviceOrderPermissions'
import DropdownLink from '../../../../components/navigation/DropdownLink'
import Icon from '../../../../components/shapes/Icon'

const EventActionsDropdown = ({ event }) => {
  const { serviceOrder } = event
  const { canSeeResume } = useServiceOrderPermissions(serviceOrder)

  const openDetailsModal = useOpenServiceOrderModal()
  const { toggle } = useAccordionActions()
  const navigate = useNavigationWithModalCloser()

  const options = [
    ...appendIf(!!event.reply, {
      value: 'Ver respostas',
      icon: 'BsCardChecklist',
      onClick: () => toggle()
    }),

    ...appendIf(!!serviceOrder, {
      value: 'Ver detalhes da atividade',
      icon: 'BsSearch',
      onClick: () => openDetailsModal(serviceOrder)
    }),

    ...appendIf(canSeeResume, {
      value: 'Ver resumo completo',
      icon: 'BsFileRichtext',
      onClick: () => navigate(`/service-orders/${serviceOrder.id}/resume`),
      to: `/service-orders/${prop('id', serviceOrder)}/resume`
    })
  ]

  return <DropdownLink fromRight actionContent={<Icon name="BsThreeDots" />} options={options}></DropdownLink>
}

export default EventActionsDropdown
